import * as Types from '../../../../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateQueryUserConfigVariables = Types.Exact<{
  input: Types.UpdateQueryUserConfigInput;
}>;

export type UpdateQueryUserConfig = {
  updateQueryUserConfig: Pick<Types.DataLakeQuery, 'id'> & {
    userConfig?: Types.Maybe<
      Pick<Types.QueryUserConfig, 'queryId'> & {
        chartProperties: Array<
          Pick<
            Types.QueryChartPropertyConfig,
            | 'limit'
            | 'order'
            | 'chartType'
            | 'colorHexes'
            | 'propertyId'
            | 'sortDirection'
            | 'propertyPath'
            | 'propertyTableName'
            | 'propertyDisplayName'
          >
        >;
        tableProperties: Array<
          Pick<
            Types.QueryTablePropertyConfig,
            'order' | 'propertyId' | 'propertyDisplayName' | 'propertyTableName' | 'propertyPath'
          >
        >;
      }
    >;
  };
};

export const UpdateQueryUserConfigDocument = gql`
  mutation UpdateQueryUserConfig($input: UpdateQueryUserConfigInput!) {
    updateQueryUserConfig(input: $input) {
      id
      userConfig {
        queryId
        chartProperties {
          limit
          order
          chartType
          colorHexes
          propertyId
          sortDirection
          propertyPath
          propertyTableName
          propertyDisplayName
        }
        tableProperties {
          order
          propertyId
          propertyDisplayName
          propertyTableName
          propertyPath
        }
      }
    }
  }
`;
export type UpdateQueryUserConfigMutationFn = Apollo.MutationFunction<
  UpdateQueryUserConfig,
  UpdateQueryUserConfigVariables
>;

/**
 * __useUpdateQueryUserConfig__
 *
 * To run a mutation, you first call `useUpdateQueryUserConfig` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueryUserConfig` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueryUserConfig, { data, loading, error }] = useUpdateQueryUserConfig({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQueryUserConfig(
  baseOptions?: Apollo.MutationHookOptions<UpdateQueryUserConfig, UpdateQueryUserConfigVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateQueryUserConfig, UpdateQueryUserConfigVariables>(
    UpdateQueryUserConfigDocument,
    options,
  );
}
export type UpdateQueryUserConfigHookResult = ReturnType<typeof useUpdateQueryUserConfig>;
export type UpdateQueryUserConfigMutationResult = Apollo.MutationResult<UpdateQueryUserConfig>;
export type UpdateQueryUserConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateQueryUserConfig,
  UpdateQueryUserConfigVariables
>;
export function mockUpdateQueryUserConfig({
  data,
  variables,
  errors,
}: {
  data: UpdateQueryUserConfig;
  variables?: UpdateQueryUserConfigVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: UpdateQueryUserConfigDocument, variables },
    result: { data, errors },
  };
}
